<template>
  <section class="pa-3 pa-md-5">
    <slot />
  </section>
</template>

<script>
export default {};
</script>
